/**
 * 未送信ドラフトの回収（スイープ）を仕掛けるフック。
 *
 * 起動画面になり得るビュー（タイムライン・一覧）は**すべてこれを呼ぶ**
 * （docs/01-requirements.md §5.1 P0）。どちらを起動画面にしても未送信ドラフトが
 * サーバーへ届くことが、絶対規則2（入力済みのテキストを失わない）の担保になっている。
 *
 * 抑えるのは実行回数ではなく同時実行である。マウント、通信復帰、前面復帰のたびに
 * スイープを要求し、実行中なら完了後の再スイープとして予約する。通知は同じ回につき
 * 1 度だけにする。調停ロジックは React 非依存の StartupSweepCoordinator が持つ。
 */

import { useEffect } from 'react';
import { runStartupMaintenance } from '@app/save/startup';
import {
  StartupSweepCoordinator,
  subscribeStartupMaintenance,
} from '@app/save/startup-sweep';
import { useToast } from '@app/ui/toast';

const coordinator = new StartupSweepCoordinator(runStartupMaintenance);

export function useStartupMaintenance(): void {
  const toast = useToast();

  useEffect(
    () =>
      subscribeStartupMaintenance({
        coordinator,
        windowEvents: window,
        documentEvents: document,
        isVisible: () => document.visibilityState === 'visible',
        announce: (recovered) =>
          toast.show(`未送信の下書き ${recovered} 件を送信しました`),
      }),
    [toast],
  );
}
